import { Box, Typography, Container, Divider, SvgIcon } from "@mui/material";
import { Link } from "react-router-dom";
import { KeyboardBackspace } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import img54 from "../../assets/ocesha_images/ocesha_logo.png";
import { useState, useEffect } from "react";

import { object, string, TypeOf } from "zod";
import { useSubscribeNewsMutation } from "../../redux/api/authApi";
import { toast } from "react-toastify";
import { useForm, FormProvider, SubmitHandler } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

const newsSubscribeform = object({
  email: string()
    .min(1, "Email address is required")
    .email("Email address is invalid"),
  status: string(),
});

export type NewsSubscriptionForm = TypeOf<typeof newsSubscribeform>;
const DataDeletionPage = () => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate("/codegenie/smart_contracts");
  };
  const [subscribeVal, setSubscribeVal] = useState<NewsSubscriptionForm>({
    email: "",
    status: "",
  });
  const [newsSubsctiptionMutation, newsSubscriptionState] =
    useSubscribeNewsMutation();

  const methods = useForm<NewsSubscriptionForm>({
    resolver: zodResolver(newsSubscribeform),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;

  const onSubmitHandler: SubmitHandler<NewsSubscriptionForm> = (values) => {
    newsSubsctiptionMutation(values);
  };

  const handleSubscribeNews = () => {
    newsSubsctiptionMutation(subscribeVal)
      .unwrap()
      .then((response) => {
        console.log("news subscription=>", response);
        const status = response.status;

        console.log(status);
        if (status === "success") {
          toast.success(response.message);
          setSubscribeVal({
            email: "",
            status: "",
          });
        }
      })
      .catch((error) => {
        toast.error(error?.data?.detail ?? "Something went wrong!");
        console.error("Error sending query:", error);
      });
  };
  return (
    <>
      <Container maxWidth="lg">
        <nav className="navbar navbar-expand-md">
          <div className="container-fluid">
            <a className="navbar-brand" href={process.env.REACT_APP_LOGOUT_DOMAIN || "https://ocesha.ai"}>
              <img src={img54} alt="" style={{ height: "70px" }} />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarScroll"
              aria-controls="navbarScroll"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="">
                <i className="bi bi-list text-white" />
              </span>
            </button>

            <div className="collapse navbar-collapse" id="navbarScroll">
              <ul className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll gap-4">
                <li className="nav-item">
                  <a
                    className="nav-link nav_active"
                    style={{ color: "#4ba5eb", fontWeight: 800 }}
                    href="/"
                  >
                    Home
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link nav_simple"
                    href="https://ocesha-inc.getrewardful.com/signup?_gl=1*1lh53li*_gcl_au*MTc0Njg4MTI3Ni4xNzQ2NzMwMTA0*_ga*MTY2NzI5OTM0OC4xNzQ2NzMwMTA0*_ga_YJYFH7ZS27*czE3NDY3MzAxMDMkbzEkZzEkdDE3NDY3MzEwNjckajM3JGwwJGgw"
                  >
                    Affiliate
                  </a>
                </li>
              </ul>

              <div className="d-flex gap-4" role="search">
                <button
                  className="button_leniar px-3"
                  type="submit"
                  onClick={() => {
                    navigate("/signup");
                  }}
                >
                  Try Now
                </button>
                <button
                  className="btn btn-outline-primary px-3"
                  onClick={() => {
                    navigate("/signin");
                  }}
                >
                  Sign in
                </button>
              </div>
            </div>
          </div>
        </nav>
        <Box py={5}>
            <Typography
                variant="h2"
                color="text.secondary"
                fontWeight={600}
                textAlign="center"
                mb={8}
            >
                OceSha.ai Data Deletion Instructions
            </Typography>

            <Typography>
                Last Updated: June 2026
                <br />
                <br />
                At OceSha.ai, we believe users should have control over their personal
                information, uploaded content, Digital Twin data, and account information.
                <br />
                <br />
                This page explains how you may access, export, and request deletion of your
                OceSha.ai account and associated personal data.
            </Typography>

            {/* Delete Account */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                Delete Your Account
            </Typography>

            <Typography>
                You may permanently delete your OceSha.ai account directly from within the
                platform.
            </Typography>

            <Typography variant="h5" color="text.secondary" mt={3} mb={2}>
                To Delete Your Account
            </Typography>

            <Box component="ol" sx={{ pl: 4 }}>
                <li>Log in to your OceSha.ai account.</li>
                <li>Navigate to Settings.</li>
                <li>Open Data & Privacy.</li>
                <li>Select Delete Account.</li>
                <li>Review the deletion notice and confirm your request.</li>
            </Box>

            <Typography mt={2}>
                Once confirmed, OceSha.ai will begin the account deletion process.
            </Typography>

            {/* Download Data */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                Download Your Data
            </Typography>

            <Typography>
                Before deleting your account, you may download a copy of your available
                account data.
            </Typography>

            <Typography variant="h5" color="text.secondary" mt={3} mb={2}>
                To Download Your Data
            </Typography>

            <Box component="ol" sx={{ pl: 4 }}>
                <li>Log in to your OceSha.ai account.</li>
                <li>Navigate to Settings.</li>
                <li>Open Data & Privacy.</li>
                <li>Select Download Your Data.</li>
            </Box>

            <Typography mt={2}>
                A downloadable export of available account data will be prepared and made
                available through the platform.
            </Typography>

            {/* Information Subject to Deletion */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                Information Subject to Deletion
            </Typography>

            <Typography>
                Subject to applicable legal, security, and operational retention
                requirements, OceSha.ai may delete or anonymize the following information:
            </Typography>

            <Typography variant="h5" color="text.secondary" mt={4} mb={2}>
                Account Information
            </Typography>

            <Box component="ul">
                <Box component="li">Name</Box>
                <Box component="li">Email address</Box>
                <Box component="li">Profile information</Box>
                <Box component="li">Profile image</Box>
                <Box component="li">Account preferences</Box>
                <Box component="li">Communication preferences</Box>
            </Box>

            <Typography variant="h5" color="text.secondary" mt={4} mb={2}>
                Uploaded Content
            </Typography>

            <Box component="ul">
                <Box component="li">Documents</Box>
                <Box component="li">PDFs</Box>
                <Box component="li">Presentations</Box>
                <Box component="li">Resumes</Box>
                <Box component="li">Website references</Box>
                <Box component="li">Audio recordings</Box>
                <Box component="li">Video files</Box>
                <Box component="li">Images</Box>
                <Box component="li">Educational materials</Box>
                <Box component="li">Other uploaded User Content</Box>
            </Box>

            <Typography variant="h5" color="text.secondary" mt={4} mb={2}>
                Digital Twin Data
            </Typography>

            <Box component="ul">
                <Box component="li">Digital Twin configuration data</Box>
                <Box component="li">Interview responses</Box>
                <Box component="li">Expertise data</Box>
                <Box component="li">Knowledge representations</Box>
                <Box component="li">Personalization settings</Box>
                <Box component="li">Digital Twin training materials</Box>
            </Box>

            <Typography variant="h5" color="text.secondary" mt={4} mb={2}>
                Voice Data
            </Typography>

            <Box component="ul">
                <Box component="li">Voice recordings</Box>
                <Box component="li">Voice samples</Box>
                <Box component="li">Speech pattern information</Box>
                <Box component="li">Voice interaction transcripts</Box>
                <Box component="li">Synthetic voice configuration data</Box>
            </Box>

            <Typography variant="h5" color="text.secondary" mt={4} mb={2}>
                Generated Content
            </Typography>

            <Box component="ul">
                <Box component="li">Blogs</Box>
                <Box component="li">Social posts</Box>
                <Box component="li">Courses</Box>
                <Box component="li">Clips</Box>
                <Box component="li">Podcasts</Box>
                <Box component="li">Images</Box>
                <Box component="li">Profile Page content</Box>
                <Box component="li">
                Other AI-generated content associated with your account
                </Box>
            </Box>

            <Typography variant="h5" color="text.secondary" mt={4} mb={2}>
                Engagement Data
            </Typography>

            <Box component="ul">
                <Box component="li">Messages</Box>
                <Box component="li">Leads</Box>
                <Box component="li">Audience engagement records</Box>
                <Box component="li">Communication history</Box>
                <Box component="li">Related metadata</Box>
            </Box>

            {/* Public Content */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                Public Profile Pages and Published Content
            </Typography>

            <Typography>
                If you have created a public Profile Page or published content through
                OceSha.ai:
            </Typography>

            <Box component="ul">
                <Box component="li">
                Public Profile Pages may be removed from public access.
                </Box>
                <Box component="li">
                Public content hosted by OceSha.ai may be removed, archived, disabled,
                redirected, or placed into a limited preview state.
                </Box>
                <Box component="li">
                Editing and publishing functionality may be disabled following account
                deletion.
                </Box>
            </Box>

            <Typography mt={2}>
                However, previously published content may have been indexed by search
                engines, referenced by AI systems, cached by third-party services, archived
                externally, or republished by third parties.
                <br />
                <br />
                OceSha.ai cannot guarantee removal of content from search engines, AI
                systems, web archives, social platforms, or other third-party systems
                outside of OceSha's control.
            </Typography>

            {/* Third Party */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                Third-Party Integrations
            </Typography>

            <Typography>
                Users may connect third-party services including LinkedIn, Facebook,
                YouTube, X (Twitter), Google, Stripe, and other supported integrations.
                <br />
                <br />
                Deleting your OceSha.ai account will remove OceSha's ability to access
                connected services associated with your account.
                <br />
                <br />
                Content previously published to third-party platforms remains subject to
                those platforms' policies and retention practices.
            </Typography>

            {/* Retained Information */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                Information We May Retain
            </Typography>

            <Typography>
                Certain information may be retained where reasonably necessary to:
            </Typography>

            <Box component="ul">
                <Box component="li">Comply with legal obligations</Box>
                <Box component="li">Satisfy tax and accounting requirements</Box>
                <Box component="li">Detect and prevent fraud</Box>
                <Box component="li">Protect platform security</Box>
                <Box component="li">Resolve disputes</Box>
                <Box component="li">Enforce agreements</Box>
                <Box component="li">Maintain system integrity</Box>
                <Box component="li">
                Support backup and disaster recovery processes
                </Box>
            </Box>

            {/* Ownership */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                Ownership of Content
            </Typography>

            <Typography>
                You retain ownership of the content you upload to OceSha.ai, subject to the
                rights granted under our Terms of Service and Privacy Policy to operate and
                provide the Services.
                <br />
                <br />
                Deletion of your account does not transfer ownership of your content to
                OceSha.ai.
            </Typography>

            {/* Commitments */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                Our Privacy Commitments
            </Typography>

            <Box component="ul">
                <Box component="li">We do not sell personal information.</Box>
                <Box component="li">We do not sell private uploaded content.</Box>
                <Box component="li">We do not sell voice data.</Box>
                <Box component="li">
                Private uploaded content is not used to train public AI models unless
                expressly disclosed and separately consented to by the user.
                </Box>
                <Box component="li">
                Users retain ownership of their uploaded content.
                </Box>
            </Box>

            {/* Processing Time */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                Processing Time
            </Typography>

            <Typography>
                Most deletion requests are processed promptly after confirmation.
                <br />
                <br />
                In some circumstances, complete removal from backup systems, disaster
                recovery systems, and supporting infrastructure may take up to 30 days or
                longer where required by law or operational necessity.
            </Typography>

            {/* Unable to Access */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                Unable to Access Your Account
            </Typography>

            <Typography>
                If you cannot access your account and need assistance with deletion, please
                contact:
                <br />
                <br />
                support@ocesha.com
                <br />
                <br />
                Please include:
            </Typography>

            <Box component="ul">
                <Box component="li">Your name</Box>
                <Box component="li">The email address associated with your account</Box>
                <Box component="li">A request for account deletion</Box>
            </Box>

            <Typography mt={2}>
                We may request information necessary to verify your identity before
                processing the request.
            </Typography>

            {/* Contact */}
            <Typography variant="h4" color="text.secondary" mt={5} mb={2}>
                Contact Us
            </Typography>

            <Typography>
                For questions regarding privacy, data deletion, or privacy rights, please
                contact:
                <br />
                <br />
                OceSha, Inc.
                <br />
                <a href="mailto:support@ocesha.com">support@ocesha.com</a>
                <br />
                <a href="https://ocesha.ai" target="_blank" rel="noreferrer">
                https://ocesha.ai
                </a>
            </Typography>

            <Link
                to="/signin"
                style={{
                    display: "flex",
                    marginTop: 40,
                    textDecoration: "none",
                    color: "white",
                }}
                >
                <SvgIcon sx={{ mr: 1 }}>
                    <KeyboardBackspace />
                </SvgIcon>
                Back to log in
            </Link>
        </Box>
      </Container>
    </>
  );
};

export default DataDeletionPage;